import attendance from "../../icons/apps/attendance.svg";
import contacts from "../../icons/apps/contacts.svg";
import dashboards from "../../icons/apps/dashboards.svg";
import expense from "../../icons/apps/expense.svg";
import hr from "../../icons/apps/hr.svg";
import mrp from "../../icons/apps/mrp.svg";
import overview from "../../icons/apps/overview.svg";
import purchase from "../../icons/apps/purchase.svg";
import repair from "../../icons/apps/repair.svg";
import route from "../../icons/apps/route.svg";
import sales from "../../icons/apps/sales.svg";
import settings from "../../icons/apps/settings.svg";
import stock from "../../icons/apps/stock.svg";

/*
 * Иконки разделов Д2 из chmk-erp (addons/chmk_ui/static/src/img/apps):
 * белый контурный глиф на чёрной плашке со срезом 45°. «Огляд» это щит
 * 4UMK. SVG не править руками: источник глифов ops/app_icons.py в chmk-erp.
 */
export const appIcons = {
  attendance,
  contacts,
  dashboards,
  expense,
  hr,
  mrp,
  overview,
  purchase,
  repair,
  route,
  sales,
  settings,
  stock,
} as const;

export type AppIconName = keyof typeof appIcons;

export interface AppIconProps {
  name: AppIconName;
  size?: number;
  className?: string;
}

/** Декоративная: подпись раздела всегда рядом текстом. */
export function AppIcon({ name, size = 24, className }: AppIconProps) {
  return <img src={appIcons[name]} width={size} height={size} alt="" className={className} draggable={false} />;
}
